"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _icon = _interopRequireDefault(require("../Icon/icon"));

var _loader = _interopRequireDefault(require("../Loader/loader"));

var _dismissIcon = _interopRequireDefault(require("../Icon/dismissIcon"));

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _toastActions = _interopRequireDefault(require("./toastActions"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function convertToSeconds(duration) {
  var unit = 1000;
  return parseFloat(duration / unit);
}

function Toast(_ref) {
  var children = _ref.children,
      id = _ref.id,
      withLoader = _ref.withLoader,
      dismissible = _ref.dismissible,
      forceTimerUpdate = _ref.forceTimerUpdate,
      timeShift = _ref.timeShift,
      dismissDelay = _ref.dismissDelay,
      onDismiss = _ref.onDismiss,
      props = _objectWithoutProperties(_ref, ["children", "id", "withLoader", "dismissible", "forceTimerUpdate", "timeShift", "dismissDelay", "onDismiss"]);

  var timerId = forceTimerUpdate ? Math.random() : id;
  var messageClasses = ['co-message', 'co-message--block'];
  return _react.default.createElement(_styler.default, {
    classNames: messageClasses,
    modifiers: props
  }, function (styles) {
    return _react.default.createElement("div", _extends({
      id: id,
      className: styles
    }, (0, _getNativeProps.default)(props)), withLoader ? _react.default.createElement(_loader.default, {
      inline: true,
      small: true
    }) : _react.default.createElement(_icon.default, {
      name: selectIcon(props)
    }), _react.default.createElement("div", {
      className: "co-message__content"
    }, children), dismissible ? _react.default.createElement(_dismissIcon.default, {
      onClick: onDismiss,
      ariaLabel: "Close",
      small: true
    }) : null, dismissDelay ? _react.default.createElement(ToastTimer, {
      key: timerId,
      timeShift: timeShift,
      initialDuration: dismissDelay
    }) : null);
  });
}

var ToastTitle = function ToastTitle(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("strong", {
    className: "co-message__title"
  }, children);
};

var ToastTimer = function ToastTimer(_ref3) {
  var initialDuration = _ref3.initialDuration,
      timeShift = _ref3.timeShift;
  return _react.default.createElement("div", {
    className: "co-message__timer",
    style: {
      animationDuration: "".concat(convertToSeconds(initialDuration), "s"),
      animationDelay: timeShift ? "-".concat(convertToSeconds(timeShift), "s") : null
    }
  });
};

var selectIcon = function selectIcon(_ref4) {
  var info = _ref4.info,
      success = _ref4.success,
      warning = _ref4.warning,
      danger = _ref4.danger,
      error = _ref4.error,
      feature = _ref4.feature;

  if (success) {
    return _icon.default.CHECK_CIRCLE;
  } else if (warning) {
    return _icon.default.WARNING;
  } else if (danger || error) {
    return _icon.default.ERROR;
  } else if (feature) {
    return _icon.default.STAR_CIRCLE;
  } else {
    return _icon.default.INFO;
  }
};

var exclusiveStatusProps = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('info', 'success', 'warning', 'danger', 'error', 'feature');
Toast.defaultProps = {
  onDismiss: function onDismiss() {},
  onExit: function onExit() {}
};
Toast.propTypes = {
  children: _propTypes.any.isRequired,
  id: _propTypes.string,
  withLoader: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  info: exclusiveStatusProps,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  success: exclusiveStatusProps,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  warning: exclusiveStatusProps,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  danger: exclusiveStatusProps,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  error: exclusiveStatusProps,

  /** {bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@ */
  feature: exclusiveStatusProps,
  small: _propTypes.bool,
  dismissible: _propTypes.bool,

  /** {bool, number} */
  dismissDelay: (0, _airbnbPropTypes.or)([_propTypes.bool, _airbnbPropTypes.nonNegativeInteger]),
  onDismiss: _propTypes.func,
  onExit: _propTypes.func // Prop used by Toaster to add on exit callback

};
ToastTitle.propTypes = {
  children: _propTypes.any.isRequired
};
ToastTitle.displayName = 'Toast.Title';
_toastActions.default.displayName = 'Toast.Actions';
Toast.Title = ToastTitle;
Toast.Actions = _toastActions.default;
var _default = Toast;
exports.default = _default;
Toast.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Toast",
  "props": {
    "onDismiss": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onExit": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "withLoader": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "info": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "success": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "danger": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "feature": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStatusProps"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@info@@ @@success@@ @@warning@@ @@danger@@ @@error@@ @@feature@@"
    },
    "small": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissible": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "dismissDelay": {
      "type": {
        "name": "custom",
        "raw": "or([\n  bool,\n  nonNegativeInteger\n])"
      },
      "required": false,
      "description": "{bool, number}"
    }
  }
};